import { initI18n } from 'www/utils'

(async function IIFE() {
  try {
    const { i18next, userLanguage } = await initI18n({ bundle: 'doctors.blocks/common/b-phonebook' })

    const btn = document.querySelector('.b-phonebook__button_js')

    if (!btn) {
      return
    }

    const container = document.querySelector('.b-phonebook_js')

    btn.addEventListener('click', () => {
      container.classList.toggle('b-phonebook_is_expanded')

      if (container.classList.contains('b-phonebook_is_expanded')) {
        btn.innerHTML = i18next.t('Скрыть', { ns: userLanguage })
      } else {
        btn.innerHTML = i18next.t('Показать все контакты', { ns: userLanguage })
      }

      window.dispatchEvent(new Event('redraw'))
    })
  } catch { /* Empty */ }
}())
